import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { AssessmentResult } from '../entities/AssessmentResult'

@InputType()
export class ProcessScanArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => ID)
  resultId: string

  @Field(() => Float)
  pageNumber: number

  @Field(() => String)
  imageUrl: string
}

export interface IProcessScan extends IAction<AssessmentResult, ProcessScanArgs> {}
